const weekDays = [
  'nedeľa', 'pondelok', 'utorok', 'streda', 'štvrtok', 'piatok', 'sobota', 'nedeľa'
]

const englishWeekDays = [
  'sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'
]

const months = [
  'január', 'február', 'marec', 'apríl', 'máj', 'jún', 'júl',
  'august', 'september', 'október', 'november', 'december'
]

const englishMonths = [
  'january', 'february', 'march', 'april', 'may', 'jun', 'july',
  'august', 'september', 'october', 'november', 'december'
]

export {
  englishMonths,
  englishWeekDays,
  weekDays,
  months,
}

export default {
  englishMonths,
  englishWeekDays,
  weekDays,
  months,
}



// WEBPACK FOOTER //
// ./src/locale/date.js